<template>
  <section role="main" class="content-body">
    <header class="page-header">
      <h2>校外賃居租金補貼申請</h2>
      <div class="right-wrapper">
        <ol class="breadcrumbs">
          <li><a href="/"><i class="fa fa-home"></i></a></li>
          <li><span>賃居管理</span></li>
          <li><span>校外賃居租金補貼申請</span></li>
        </ol>
      </div>
    </header>
    <div class="row">
      <div class="col-md-12">
        <section class="panel">
          <ul class="nav nav-tabs" role="tablist">
            <li><router-link :to="'/rent-subsidy/list'">申請清單</router-link></li>
            <li class="active"><router-link :to="'/rent-subsidy/timeSetting'">開放時間設定</router-link></li>
            <li><router-link :to="'/rent-subsidy/treaty'">設定隱私權宣告、申請資訊說明</router-link></li>
          </ul>
          <header class="panel-heading"><h2 class="panel-title">設定開放時間</h2></header>
          <div class="panel-body container-fluid">
            <div class="row form-group">
              <div class="col-md-12 form-group">
                <label for="schYear" class="column-required">學年度 : </label>
                <input type="text" class="form-control" v-validate="'required'" v-model="form.schYear" name="schYear" id="schYear" :style="{width:'auto', display:'inline-block'}"/>
              </div>
              <div class="col-md-12 form-group">
                <label for="smtr" class="column-required">學期 : </label>
                <select id="smtr" v-validate="'required'" v-model="form.smtr" name="smtr" class="form-control" :style="{width:'auto', display:'inline-block'}">
                  <option value="">請選擇</option>
                  <option value="1">1</option>
                  <option value="2">2</option>
                </select>
              </div>
              <div class="col-md-12 form-group">
                <label class="column-required">開放時間 : </label>
                <datepicker :format="customFormatter" :language="zh" v-validate="'required'" v-model="form.startDate" name="startDate" input-class="form-control topIndex" :style="{width:'auto', display:'inline-block'}" /> ~
                <datepicker :format="customFormatter" :language="zh" v-validate="'required'" v-model="form.endDate" name="endDate" input-class="form-control topIndex" :style="{width:'auto', display:'inline-block'}" />
              </div>
            </div>
            <div class="row form-group">
              <div class="col-md-12">
                <div class="col-md-2"></div>
                <div class="col-md-2 col-xs-3"></div>
                <div class="col-md-2 col-xs-3">
                  <button @click="handleCancel" class="btn btn-default btn-block">取消</button>
                </div>
                <div class="col-md-2 col-xs-3">
                  <button @click="handleSave" class="btn btn-primary btn-block">儲存</button>
                </div>
                <div class="col-md-2 col-xs-3"></div>
                <div class="col-md-2"></div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      form: {
        schYear: "",
        smtr: "",
        startDate: null,
        endDate: null
      }
    };
  },
  created() {
    this.$axios.get("/api/systemsetting?key=RentSubsidyTimeSetting").then(resp => {
      if (resp.data.data && resp.data.data.value) {
        this.form = JSON.parse(resp.data.data.value);
      }
    });
  },
  methods: {
    handleCancel() {
      this.$router.go(-1);
    },
    handleSave() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          const body = {
            key: "RentSubsidyTimeSetting",
            value: JSON.stringify(this.form)
          };
          this.$axios.post("/api/systemsetting", body).then(resp => {
            if (resp.data.status === "success") {
              this.$router.push({ path: "/rent-subsidy/list" });
            } else {
              bootbox.alert(resp.data.msg);
            }
          });
        } else {
          bootbox.alert("請確認必填欄位是否有填寫");
        }
      });
    }
  }
};
</script>

<style scoped>
</style>
